import { useRef } from 'react';

import { useLegalClientSaveActivity } from 'api/requests';
import { useServerErrorNotify } from 'hooks';
import { useTranslation } from 'libs/i18n';

import { CompanyActivityFormType } from '../forms/companyActivityForm';
import { getInitialData, getSubmitData } from '../helpers/companyActivity';

import { useOnboardingContext } from './useOnboardingContext';

export const useCompanyActivity = () => {
  const { t } = useTranslation();
  const { goToBack, goToNext, data } = useOnboardingContext();

  const {
    loading: submitLoading,
    error,
    saveActivity,
  } = useLegalClientSaveActivity();

  const initialValues = useRef(
    getInitialData(data.legalClient?.activity, t)
  ).current;

  const onSubmit = async (values: CompanyActivityFormType) => {
    const submitData = getSubmitData(values);
    await saveActivity(data.legalClient?.id!, submitData);
    goToNext();
  };

  useServerErrorNotify(error);

  return {
    onSubmit,
    goToBack,
    submitLoading,
    initialValues,
  };
};
